import { createAction } from '@reduxjs/toolkit'

export const fetchSEOPages = createAction('productFamilies/fetchSEOPages')
export const updateSEOPage = createAction('productFamilies/updateSEOPage')
export const createSEOPage = createAction('productFamilies/createSEOPage')
export const changeSEOPagePublishState = createAction(
  'productFamilies/changeSEOPagePublishState'
)
